import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import { CgProfile } from "react-icons/cg";
import { IoPhonePortraitSharp } from "react-icons/io5";

export default function Refer() {
  const [users, setUsers] = useState([]);
  console.warn("users",users)
  const [loading1, setLoading] = useState(false);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    try {
      setLoading(true);

      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const url = `${process.env.REACT_APP_API_URL}/user-refferlist`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response?.data?.data) {
        setUsers(response.data.data);
      }

    } catch (error) {
      console.error("Error loading user:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section id="play" className='margin-bottom-88'>
        <div className="playsection">
          <Container>
            <div className="d-flex justify-content-center backgroundheadingdesign">
              {/* Optional heading can go here */}
            </div>
            <div className="bg-white border-radius-8">
              <div className="row">

                {/* {users.map((user, index) => (
                  <div className="col-md-12" key={index}>
                    <div className="gamebg market">
                      <div className="d-flex justify-content-between gameplaybattle">
                        <div className="marketnamepaly marketnamelist1">
                          <h3 className='animate-charcter animationtittle markettitlename'>
                            <CgProfile/>{user.FullName}</h3>
                          <div className="d-flex align-items-center">
                          <i class="bi bi-phone-vibrate"></i>                            <p className='animate-charcter mb-0 ms-2'>
                            {user.mob}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))} */}


                {users == "" ? (
<p style={{
  color: "#ff4c4c",
  // backgroundColor: "#1e1e1e",
  padding: "10px",
  borderRadius: "6px",
  textAlign: "center",
  margin: "20px auto",
  width: "fit-content"
}}>
  No data
</p>


) : (

    users.map((user, index) => (
    <div className="col-md-12" key={index}>
      <div className="gamebg market">
        <div className="d-flex justify-content-between gameplaybattle">
          <div className="marketnamepaly marketnamelist1">
            <h3 className="animate-charcter animationtittle markettitlename">
              <CgProfile /> {user.FullName}
            </h3>
            <div className="d-flex align-items-center">
              <i className="bi bi-phone-vibrate"></i>
              <p className="animate-charcter mb-0 ms-2">{user.mob}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))
)}

              </div>
            </div>
          </Container>
        </div>
        {loading1 && (
          <div className="spinner-wrapper">
            <div className="loadernew2"></div>
          </div>
        )}
      </section>
    </>
  );
}
